import extendEditorForNormalization from './extendEditorForNormalization';
import normalizeBlocks from './normalizeBlocks';

export const Normalization = {
    extendEditorForNormalization,
    normalizeBlocks,
};
